import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@ridango/core';

import { CoreUiModule } from '../core-ui/core-ui.module';
import { RecoverPasswordEmailComponent } from './components/recover-password-email/recover-password-email.component';
import { RecoverPasswordComponent } from './components/recover-password/recover-password.component';

@NgModule({
    imports: [CommonModule, CoreModule, FormsModule, ReactiveFormsModule, CoreUiModule, TranslateModule],
    declarations: [RecoverPasswordEmailComponent, RecoverPasswordComponent],
    exports: [RecoverPasswordEmailComponent, RecoverPasswordComponent],
})
export class OauthAccountModule {}
